import validate from "/usr/src/app/content/n3-packages-849b228d-a260-4952-954d-6725ec0ef713/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-packages-849b228d-a260-4952-954d-6725ec0ef713/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}